import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useRouter } from 'next/router';
import { useAuth } from '../../contexts/AuthContext';
import Head from 'next/head';
import Link from 'next/link';

export default function Login() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [User, setUser] = useState('');
  const router = useRouter();
  const { login } = useAuth();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const fetchUserProfile = useCallback(() => {

    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          return;
        } else {
          router.push('/world');
        }
      } catch (err) {
        // console.error('Error fetching user profile:', err);
        //setError(err.response?.data?.error || err.message || 'An error occurred');
        if (err.response?.status === 401) {
          localStorage.removeItem('token');
        }

        if (err.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.error('Error data:', err.response.data);
          setError(err.response.data.message || 'An error occurred');
        } else if (err.request) {
          // The request was made but no response was received
          // console.error('Error request:', err.request);
          setError('No response received from server');
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.error('Error message:', err.message);
          setError('An error occurred');
        }
      }
    };
    fetchData()

  },[])

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post('/api/auth/login', formData);
      if (data.token) {
        login(data.token);
        router.push('/journals');
      } else {
        setError('Login failed. Please try again.');
      }
    } catch (err) {
      // console.error(err);
      setError(err.response?.data?.error || 'An error occurred during login.');
    }
  };

  return (
    <>
      <Head>
        <title>Login - Sojot, Social Jot</title>
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap" rel="stylesheet" />
      </Head>
      <div className="min-h-screen bg-gradient-to-b from-white to-gray-100 flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 font-inter">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h1 className="text-center text-5xl font-black text-gray-900 mb-2">
              <span className="bg-clip-text">
                Sojot
              </span>
            </h1>
            <h2 className="text-center text-3xl font-bold text-gray-900">
              Sign in to your account
            </h2>
          </div>
          {error && <p className="text-red-500 text-center">{error}</p>}
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                  placeholder="Email address"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Sign in
              </button>
            </div>
          </form>
          <div className="text-center">
            <p className="mt-2 text-sm text-gray-600">
              Dont have an account?{' '}
              <Link href="/auth/register" className="font-medium text-blue-600 hover:text-blue-500">
                Sign up
              </Link>
            </p>
            <p className="mt-2 text-sm text-gray-600">
              Forgot Password?{' '}
              <Link href="/auth/forgot-password" className="font-medium text-blue-600 hover:text-blue-500">
                Reset password
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}